import { Grid } from 'grommet'
import React, { PropsWithChildren, useMemo } from 'react'

import useDeviceSize from 'hooks/useDevice'

type Props = {
  desktopColumns: number
}
function GridWrapper({ desktopColumns, children }: PropsWithChildren<Props>) {
  const { small } = useDeviceSize()
  const columns = useMemo(
    () => (small ? { count: 1, size: 'full' } : { count: desktopColumns, size: 'flex' }),
    [desktopColumns, small],
  )
  return (
    <Grid
      gap="small"
      fill="horizontal"
      alignSelf="center"
      margin={{ top: small ? 'large' : 'small' }}
      columns={columns}>
      {children}
    </Grid>
  )
}

export default GridWrapper
